module.exports = __webpack_public_path__ + "img/cmacgm.728c6585.png";